import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { formateZeroFillDate } from "../../utils/dateUtil";
import {
  Card,
  Typography,
  Select,
  Divider,
  Input,
  DatePicker,
  message,
  Space,
} from "antd";

import {
  req_list_lrs_buildingSpace,
  req_list_lrs_spaceInformation,
  req_add_lrs_correctLog,
} from "../../api";
import moment from "moment";
const { Option } = Select;
class StudentWorksAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    log: PropTypes.object,
  };

  state = {
    isUpdate: false,
    isInsert: false,
    newItem: "",
    items: [
      "未經申請，徑行入內",
      "未經核准，徑行入內",
      "已准申請，但未曾使用",
      "已准申請，但未落實人員管制",
      "應簽到退，但未落實執行",
      "破壞設施，或未歸還物品", 
    ],
    item: {
      Uid: "",
      OperatorId: "",
      OperatorName: "",
      TroublemakerId: "",
      TroublemakerName: "",
      TroubleDescription: "",
      BuildingCode: "NONE",
      BuildingName: "",
      RoomCode: "NONE",
      RoomName: "",
      DateTag: "",
      WeekCode: "",
      TimeCode: "",
      LendUid: "NA",
    },
    buildings: [],
    rooms: [],
    selectedBuilding: "NONE",
    selectedRoom: "NONE",
    selectedDatetime: moment(new Date()),
    selectedDescription: "",
    selectedRoomInfo: null,
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.init();
  }

  componentDidMount() {
    this.init();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_buildings = async () => {
    const { token } = this.props.user;

    this.setState({ loading: true });
    const result = await req_list_lrs_buildingSpace(token);
    this.setState({ loading: false });

    const buildings = result.data;
    this.setState({ buildings });
    //console.log(buildings);
  };

  api_list_rooms = async (buildingCode) => {
    const result = await req_list_lrs_spaceInformation(buildingCode);
    const rooms = result.total > 0 ? result.data : [];
    this.setState({ rooms });
    // console.log(rooms);
  };

  api_add_item = async (item) => {
    const { token } = this.props.user;
    this.setState({ loading: true });
    const result = await req_add_lrs_correctLog(item, token);
    this.setState({ loading: false });
    if (result.status === "success") {
      // console.log(result)
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    const { log } = this.props;
    //console.log(log);
    if (log !== null) {
      if (Object.keys(log).length !== 0) {
        const {
          Uid,
          BorrowerId,
          BorrowerName,
          BuildingCode,
          BuildingName,
          RoomCode,
          RoomName,
        } = log;
        const { item } = this.state;
        item.TroublemakerId = BorrowerId;
        item.TroublemakerName = BorrowerName;
        item.BuildingCode = BuildingCode;
        item.BuildingName = BuildingName;
        item.RoomCode = RoomCode;
        item.RoomName = RoomName;
        item.LendUid = Uid;
        this.setState({ item });
      }
    } else {
      this.api_list_buildings();
    }
  };

  setRooms = (value) => {
    this.api_list_rooms(value);
  };

  range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < moment().endOf("day");
  };

  disabledDateTime = () => {
    return {
      disabledHours: () => this.range(0, 24).splice(4, 20),
      disabledMinutes: () => this.range(30, 60),
      disabledSeconds: () => [55, 56],
    };
  };

  // 操作互動處理 //////////////////////////////////////////////

  handleChange(event) {
    const { item } = this.state;
    Object.keys(item).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        item[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ item });
  }

  handleBuildingChange = (value) => {
    this.setState({
      selectedBuilding: value,
      selectedRoom: "NONE",
      selectedRoomInfo: null,
    });
    this.setRooms(value);
    //console.log(value);
  };

  handleRoomChange = (value) => {
    const { rooms } = this.state;
    const selectedRoomInfo = rooms.filter(function (item) {
      return item.RoomCode === value;
    })[0];
    this.setState({
      selectedRoom: value,
      selectedRoomInfo: selectedRoomInfo,
    });
    console.log(selectedRoomInfo);
  };

  handleDescriptChange = (value) => {
    this.setState({
      selectedDescription: value,
    });
  };

  handleDatetimeChange = (date, dateString) => {
    this.setState({
      selectedDatetime: date,
    });
  };

  onNameChange = (event) => {
    this.setState({ newItem: event.target.value });
  };

  addItem = (e) => {
    e.preventDefault();
    const { items, newItem } = this.state;
    items.push(newItem);
    this.setState(items);
  };

  handleSubmit(event) {
    event.preventDefault();
    const { log } = this.props;
    const { selectedDescription, selectedRoomInfo, selectedDatetime } =
      this.state;

    const row = this.state.item;
    const errors = [];

    if (row.TroublemakerId.trim() === "") {
      errors.push("學/職號未填");
    } else {
      if (
        row.TroublemakerId.length === 6 ||
        row.TroublemakerId.length === 9 ||
        row.TroublemakerId.length === 10
      ) {
      } else {
        errors.push("學/職號格式錯誤");
      }
    }

    if (row.TroublemakerName.trim() === "") {
      errors.push("姓名未填");
    }

    if (selectedDescription.trim() === "") {
      errors.push("未選擇違規事實");
    } else {
      row.TroubleDescription = selectedDescription.trim();
    }
    if (log === null) {
      if (selectedRoomInfo && typeof selectedRoomInfo !== "undefined") {
        const { BuildingCode, BuildingName, RoomCode, RoomTwName } =
          selectedRoomInfo;
        row.BuildingCode = BuildingCode;
        row.BuildingName = BuildingName;
        row.RoomCode = RoomCode;
        row.RoomName = RoomTwName;
      } else {
        errors.push("未選擇空間地點");
      }
    }

    if (errors.length === 0) {
      const { log } = this.props;
      const { userCode, userName } = this.props.user;
      row.OperatorId = userCode;
      row.OperatorName = userName;

      row.DateTag = formateZeroFillDate(selectedDatetime).substr(0, 10);
      row.WeekCode = formateZeroFillDate(selectedDatetime).substr(20, 1);
      row.TimeCode = formateZeroFillDate(selectedDatetime).substr(11, 8);
      if (Object.keys(log).length !== 0) {
        const { Uid } = log;
        row.LendUid = Uid;
      }
      //console.log(row);
      this.api_add_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  }

  //////////////////////////////////////////////////////////

  render() {
    const { log } = this.props;
    const {
      buildings,
      rooms,
      selectedBuilding,
      selectedRoom,
      selectedDatetime,
      items,
    } = this.state;
    const {
      TroublemakerId,
      TroublemakerName,
      BuildingName,
      RoomCode,
      RoomName,
    } = this.state.item;

    const listRooms =
      rooms.length > 0 ? (
        <>
          {rooms.map((item) => (
            <Option
              key={item.RoomCode}
              value={item.RoomCode}
              disabled={item.RoomStatus === "CLOSE"}
            >
              {item.RoomCode} {item.RoomTwName}
            </Option>
          ))}
        </>
      ) : (
        ""
      );
    //console.log(downloadUrl)
    return (
      <Card>
        <form onSubmit={this.handleSubmit}>
          <div className="form-row">
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>違規者證號
                </label>
                <input
                  type="text"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow" }}
                  name="TroublemakerId"
                  id="TroublemakerId"
                  defaultValue={TroublemakerId}
                  aria-describedby="mobileHelp"
                  placeholder="請輸入違規者學/職號"
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>違規者姓名
                </label>
                <input
                  type="text"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow" }}
                  name="TroublemakerName"
                  id="TroublemakerName"
                  defaultValue={TroublemakerName}
                  aria-describedby="mobileHelp"
                  placeholder="請輸入違規者姓名"
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="col-lg">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>違規事項
                </label>
                <Select
                  style={{ width: "100%" }}
                  onChange={this.handleDescriptChange}
                  placeholder="請選擇違規事項"
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <Divider style={{ margin: "8px 0" }} />
                      <Space align="center" style={{ padding: "0 8px 4px" }}>
                        <Input
                          placeholder="請輸入其他違規內容"
                          onChange={this.onNameChange}
                        />
                        <Typography.Link
                          onClick={this.addItem}
                          style={{ whiteSpace: "nowrap" }}
                        >
                          <span className="btn btn-sm btn-warning">
                            <i className="fas fa-plus"></i> 增加
                          </span>
                        </Typography.Link>
                      </Space>
                    </>
                  )}
                >
                  {items.map((item) => (
                    <Option key={item}>{item}</Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>查核時間
                </label>
                <DatePicker
                  onChange={this.handleDatetimeChange}
                  defaultValue={selectedDatetime}
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD HH:mm:ss"
                  disabledDate={this.disabledDate}
                  //disabledTime={this.disabledDateTime}
                  showTime={{ defaultValue: moment("00:00:00", "HH:mm:ss") }}
                />
              </div>
            </div>
          </div>
          {log === null ? (
            <div className="form-row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>
                    <span className="text-danger">*</span>所在大樓
                  </label>
                  <Select
                    style={{ width: "100%" }}
                    onChange={this.handleBuildingChange}
                    defaultValue={selectedBuilding}
                  >
                    <Option key={"NONE"} value={"NONE"}>
                      請選擇
                    </Option>
                    {buildings.map((building) => (
                      <Option
                        key={building.BuildingCode}
                        value={building.BuildingCode}
                      >
                        {building.BuildingCode}-{building.BuildingName}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>
                    <span className="text-danger">*</span>所在空間
                  </label>
                  <Select
                    style={{ width: "100%" }}
                    onChange={this.handleRoomChange}
                    defaultValue={selectedRoom}
                    value={selectedRoom}
                    allowClear
                  >
                    <Option key={"NONE"} value={"NONE"}>
                      請選擇
                    </Option>
                    {listRooms}
                  </Select>
                </div>
              </div>
            </div>
          ) : (
            <div className="form-row">
              <div className="col-lg">
                <div className="form-group">
                  <label>
                    <span className="text-danger">*</span>所在地點
                  </label>
                  <br></br>
                  {BuildingName}-({RoomCode}){RoomName}
                </div>
              </div>
            </div>
          )}
          <div className="form-row">
            <input
              type="submit"
              value="新增"
              className="btn btn-primary btn-sm btn-block"
            />
          </div>
        </form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentWorksAddModal);
